export default __webpack_public_path__ + "static/media/trulli_pizza.66737f5a.png";